import { IFeatureGroup } from "@geo/js";
import i18next from "i18next";
import React from "react";
import { useSearchContext } from "../../Contexts/SearchContext";
import { FeatureGroup } from "./FeatureGroup";
import { SearchHelp } from "./SearchHelp";
import "./SearchResults.scss";

export const SearchResults = (): JSX.Element => {
    const { searchParam, loading, error, notification, searchHelp, resultFeatures } = useSearchContext();

    const HelpSection = (): JSX.Element =>
        searchParam.length === 0 || searchHelp ? (
            <SearchHelp />
        ) : !loading ? (
            <div className="search-results-label">
                <span>{i18next.t("searchPanel.noResults")}</span>
            </div>
        ) : null;

    const ResultSection = (): JSX.Element => (
        <>
            {notification ? <div>{notification}</div> : null}
            <div className="search-results">
                {resultFeatures.map((featureGroup: IFeatureGroup) =>
                    featureGroup.features.length ? (
                        <FeatureGroup key={featureGroup.id} featureGroup={featureGroup} />
                    ) : null
                )}
            </div>
        </>
    );

    const hasResults = resultFeatures.length && resultFeatures.some((res) => res.features.length);

    return (
        <div className="scrollable-content" id="search-results-section">
            {error ? (
                <div className="search-error">{error}</div>
            ) : !resultFeatures || searchHelp ? (
                <HelpSection />
            ) : hasResults ? (
                <ResultSection />
            ) : !loading ? (
                <div className="search-error">{i18next.t("searchPanel.noResults")}</div>
            ) : null}
            {loading ? (
                <div className="results-loading">
                    <div className="line-slider" />
                </div>
            ) : null}
        </div>
    );
};
